import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=3be9bb44&scoped=true"
import script from "./DownloadButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&id=3be9bb44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be9bb44",
  null
  
)

export default component.exports